<div>
    <particles [params]="myParams" [style]="myStyle" [width]="width" [height]="height">
    </particles>
</div>